import { gql } from "@apollo/client"

export const GET_NOTIFICATIONS_COUNT = gql`
  subscription notificationCount($userId: ID!) {
    notificationCount(userId: $userId)
  }
`
